import Siema from 'siema'
blue.ready('images', '.images', rvw => {
	const slider = rvw.querySelector('.images-slider')
	const prev = rvw.querySelector('.images-prev')
	const next = rvw.querySelector('.images-next')
	let autoSlide;

	if(slider.childElementCount > 0){
		const slide = new Siema({
			selector: slider,
			easing: 'ease',
			duration: 500,
			loop: true,
			onInit: () => {
				// autoSlide = setInterval(() => {
				// 	slide.next()
				// }, 12500)
			},
			onChange: () => {
				// clearInterval(autoSlide)
				// autoSlide = setInterval(() => {
				// 	slide.next()
				// }, 12500)
			
				var iframes = slider.getElementsByTagName("iframe");
				if (iframes != null) {
					for (var i = 0; i < iframes.length; i++) {
						iframes[i].src = iframes[i].src; //causes a reload so it stops playing, music, video, etc.
					}
				}
			}
		})	

		prev.addEventListener('click', () => slide.prev())
		next.addEventListener('click', () => slide.next())	
	}	
})
